import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, from, of } from 'rxjs';
import { finalize, switchMap, shareReplay } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DataService } from 'src/app/shared/constants/data.service';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { SecurityService } from 'src/app/login-layout/Service/security.service';
import { GlobalProperties } from 'src/app/global/global-properties';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptor implements HttpInterceptor {

  private sapLogin$: Observable<any> | null = null;

  constructor(
    private ngxUiLoaderService: NgxUiLoaderService,
    private dataService: DataService,
    public generic: GenericService<any>,
    private securityService: SecurityService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // ✅ Skip interceptor
    if (request.headers.has('skip-interceptor')) {
      return next.handle(request);
    }

    // ✅ START LOADER
    this.dataService.totalRequests++;
    if (this.dataService.totalRequests === 1 && !request.url.includes('assets')) {
      this.ngxUiLoaderService.start();
    }

    const isApiUrl = request.url.startsWith(GlobalProperties.getApiUrl);
    const loginWithSSO = sessionStorage.getItem('loginWithSSO');

    // ✅ JWT Token
    if (
      isApiUrl &&
      !request.url.includes('SecurityUserLoginService') &&
      !request.url.includes('GetUserCodeByEmailService')
    ) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.securityService.getAuthToken()}`
        }
      });
    }

    // ✅ SAP SSO Header
    if (request.url.includes(GlobalProperties.getApiUrlSap) && loginWithSSO === 'true') {

      const companyID: any = sessionStorage.getItem("companyID");
      const token: any = sessionStorage.getItem('sapToken');

      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${JSON.parse(token)}`,
          "x-b1-companyid": encodeURIComponent(companyID || '')
        }
      });
    }

    const url = request.url.toLowerCase();
    const excludedEndpoints = ['login', 'securityuserloginservice'];

    const isExcluded = excludedEndpoints.some(e => url.includes(e));

    // ✅ SAP LOGIN FLOW
    if (
      (request.method === 'POST' || request.method === 'PATCH' || request.method === 'GET') &&
      !isExcluded &&
      request.url.includes(GlobalProperties.getApiUrlSap)
    ) {

      let sapDetails: any = GlobalProperties.getSapInfo;
      let data: any = sessionStorage.getItem('currentUser');
      let currentUserInfo = data ? JSON.parse(data) : null;

      let username: any;
      let password: any;

      let u_PriceListFlag= sessionStorage.getItem('u_PriceListFlag')

      if ((request.url.includes('ApprovalRequests')) || ((request.url.includes('Orders') 
        && u_PriceListFlag=="N"))) {
        username = currentUserInfo?.approverId;
        password = currentUserInfo?.approverPassword;
      } else {
        username = currentUserInfo?.postingId;
        password = currentUserInfo?.postingPassword;
      }

      // ❌ Skip login if credentials missing
      if (!username || !password) {
        return next.handle(request).pipe(
          finalize(() => this.stopLoader())
        );
      }

      // 🔁 Create login observable once
      if (!this.sapLogin$) {

        let loginUrl = `${sapDetails.ServiceLayerURL}Login`;

        const payload = {
          CompanyDB: sapDetails.CompanyDB,
          UserName: username,
          Password: password
        };

        this.sapLogin$ = from(
          this.generic.PostAPIWithOptions(loginUrl, payload, { withCredentials: true })
        ).pipe(
          switchMap((res: any) => {

            if (res?.SessionId) {
              localStorage.setItem("SAPsessionId", res.SessionId);
            }

            return of(res);
          }),
          finalize(() => {
            this.sapLogin$ = null;
          }),
          shareReplay(1)
        );
      }

      return this.sapLogin$.pipe(
        switchMap(() => next.handle(request)),
        finalize(() => this.stopLoader())
      );
    }

    // ✅ DEFAULT FLOW
    return next.handle(request).pipe(
      finalize(() => this.stopLoader())
    );
  }

  // ✅ CENTRALIZED LOADER STOP
  private stopLoader() {
    this.dataService.totalRequests--;

    if (this.dataService.totalRequests <= 0) {
      this.dataService.totalRequests = 0;
      this.ngxUiLoaderService.stop();
    }
  }
}